import { lighten, styled } from '@material-ui/core/styles';

// Share the native time picker and its appearance with sequence timestamp cards.
const TimestampValueInput = styled('input')(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: 'calc(1.8rem + 0.390625vw)',
  color: theme.palette.text.primary,
  zIndex: 3,
  position: 'relative',
  outline: 'none',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '0.6rem',
  backgroundColor: lighten(theme.palette.background.paper, 0.12),
  padding: '0 1rem',
  maxWidth: '100%',
  boxSizing: 'border-box',
  '&::-webkit-calendar-picker-indicator': {
    display: 'none',
  },
}));

export default TimestampValueInput;
